/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Appointment
 *
 * 2 = Handover
 *
 * 3 = TestDrive
 *
 * 4 = Leads
 *
 * 5 = ServiceProspecting
 *
 * 6 = MAIA
 *
 * 7 = Workings
 */
export enum TeamDiaryItemType {
  Appointment = 1,
  Handover = 2,
  TestDrive = 3,
  Leads = 4,
  ServiceProspecting = 5,
  MAIA = 6,
  Workings = 7,
}
